import React from "react";
import styled from "styled-components";
import { Header, Footer, ThemeWrapper } from 'components'
import { useLinks } from 'hooks/useLinks'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 225px);
`;

const PublicLayout = props => {
  useLinks()
  const Component = props.component;
  return (
    <ThemeWrapper>
      <div>
        <Header />
        <Content>
          <Component {...props} />
        </Content>
        <Footer />
      </div>
    </ThemeWrapper>
  );
};


export default PublicLayout;
